import { MINIMAL_PRICE_PLN_GROSZ } from '@repo/domain';
const shouldApplyMinimalPrice = MINIMAL_PRICE_PLN_GROSZ > 0;
export const applyMinimalFlatPrice = (flatPrice) => {
    // A free (zero) price stays free; only a paid price is raised to the minimum.
    if (!shouldApplyMinimalPrice || flatPrice.currency !== 'PLN' || flatPrice.amount === 0) {
        return flatPrice;
    }
    return { ...flatPrice, amount: Math.max(flatPrice.amount, MINIMAL_PRICE_PLN_GROSZ) };
};
